const getApiUrl = () => {
  if (window.location.origin.includes('app.zebel.io')) return 'https://api.zebel.io/v1';
  if (window.location.origin.includes('amazon.zebel.io')) return 'https://api.amazon.zebel.io/v1';

  return process.env.API_URL;
};

const getExportServiceUrl = () => {
  if (window.location.origin.includes('app.zebel.io')) return 'https://export.zebel.io';
  if (window.location.origin.includes('amazon.zebel.io')) return 'https://export.amazon.zebel.io';

  return process.env.EXPORT_SERVICE_URL;
};

export const formatApiError = (err) => {
  const status = err.response?.status;
  const message = err.response?.data?.message;
  if (status >= 400 && status < 500 && message) return message;
  return 'Something went wrong. Our team has been notified and is working on a fix.';
};

// The status rides along on the thrown error. SWR hands a consumer only what the fetcher
// threw, and the `/self` gate has to tell a rejected session apart from a broken server to
// choose between the login redirect and the error page.
//
// `details` rides along for the same reason: an error the caller has to *act* on rather
// than report needs the facts to act with. A 409 from a route that wants confirmation
// carries what the user is about to change, and a dialog cannot name it from a message
// string.
export const formatAndThrowApiError = (err) => {
  const error = Error(formatApiError(err));
  error.status = err.response?.status;
  error.details = err.response?.data?.details;
  throw error;
};

export { getApiUrl, getExportServiceUrl };
